import api from "services/api";

export const fetchContractGroups = async () => {
  try {
    const response = await api.get("/ContractGroup", {
      params: { pageSize: 1000, pageNumber: 1 },
    });
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching contract groups:", error);
    return [];
  }
};

export const createContractGroup = async (contractGroupData) => {
  try {
    const response = await api.post("/ContractGroup", contractGroupData);
    return response.data;
  } catch (error) {
    console.error("Error creating contract group:", error);
    throw error;
  }
};

export const updateContractGroup = async (id, contractGroupData) => {
  try {
    const response = await api.put(`/ContractGroup/${id}`, contractGroupData);
    return response.data;
  } catch (error) {
    console.error("Error updating contract group:", error);
    throw error;
  }
};

export const getContractGroup = async (id) => {
  try {
    const response = await api.get(`/ContractGroup/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching contract group ${id}:`, error);
    throw error;
  }
};

export const deleteContractGroup = async (id) => {
  try {
    const response = await api.delete(`/ContractGroup/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting contract group ${id}:`, error);
    throw error;
  }
};
